module.exports = __webpack_public_path__ + "static/media/wcb-2.09848968.png";